/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {CaptureOptions as ɵa} from './lib/interfaces/video-capture-options';